import React, { Fragment, PureComponent } from 'react'
import ListenToKeyboard from 'components/ListenToKeyboard'
import MatrixBasicMessageComposer from 'matrix-react-sdk/lib/components/views/rooms/BasicMessageComposer'
import { getCaretOffsetAndText } from 'matrix-react-sdk/lib/editor/dom'
import DocumentOffset from 'matrix-react-sdk/lib/editor/offset'
import { setCaretPosition } from 'matrix-react-sdk/lib/editor/caret'

export default class BasicMessageComposer extends PureComponent {
  setEditorCaretToEnd = () => {
    const composer = this.basicMessageComposer
    const editor = composer.getEditableRootNode()
    const editorModel = composer.props.model
    const position = editorModel.getPositionAtEnd()
    // eslint-disable-next-line no-underscore-dangle
    composer._setLastCaretFromPosition(position)
    setCaretPosition(editor, editorModel, position)
  }

  handleOnBlur = () => {
    const { setEditorFocus, onBlur } = this.props
    setEditorFocus(false)
    if (onBlur) onBlur(this)
  }

  handleOnFocus = () => {
    const { setEditorFocus, onFocus } = this.props
    setEditorFocus(true)
    if (onFocus) onFocus(this)
  }

  handleRPress = () => {
    const sel = document.getSelection()
    const composer = this.basicMessageComposer
    const editor = composer.getEditableRootNode()
    const { text } = getCaretOffsetAndText(editor, sel)
    if (text.startsWith('** ')) {
      composer.props.model.update(
        text.substr(3),
        'insertText',
        new DocumentOffset(0, false)
      )
      // eslint-disable-next-line no-underscore-dangle
      composer._modifiedFlag = true
    }
    this.setEditorCaretToEnd()
    composer.focus()
  }

  handleNPress = () => {
    const sel = document.getSelection()
    const composer = this.basicMessageComposer
    const editor = composer.getEditableRootNode()
    const editorModel = composer.props.model
    const { text } = getCaretOffsetAndText(editor, sel)
    if (!text.startsWith('** ')) {
      editorModel.update(
        `** ${text}`,
        'insertText',
        new DocumentOffset(3, false)
      )
      // eslint-disable-next-line no-underscore-dangle
      composer._modifiedFlag = true
    }
    this.setEditorCaretToEnd()
    composer.focus()
  }

  handleOnKeyDown = () => {
    const { sendStartTypingNotification, conversationId } = this.props
    sendStartTypingNotification(conversationId)
  }

  saveRef = ref => {
    const { forwardedRef } = this.props
    this.basicMessageComposer = ref
    forwardedRef(ref)
  }

  render() {
    const { forwardedRef, ...props } = this.props
    return (
      <Fragment>
        <ListenToKeyboard
          disableForInput
          preventDefault
          onR={this.handleRPress}
          onN={this.handleNPress}
        />
        <MatrixBasicMessageComposer
          {...props} // eslint-disable-line react/jsx-props-no-spreading
          showFormatBar={false}
          focusOnMount={false}
          onFocus={this.handleOnFocus}
          onBlur={this.handleOnBlur}
          onKeyDown={this.handleOnKeyDown}
          ref={this.saveRef}
        />
      </Fragment>
    )
  }
}
